export default __webpack_public_path__ + "static/media/7.f00d86f5.png";